export default __webpack_public_path__ + "static/media/Variation Theme USDC.3d84473e.png";